<template>
  <v-container>
    <v-row v-if="resultadosPersonal.length == 0" justify="center">
      <v-col cols="4">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="justify-center font-weight-bold ui-module-titlebar">Buscar personal</v-card-title>
          <v-card-text>
            <BaseInput
              class="ui-form-field"
              v-model="busquedaPersonal.nombre"
              label="Nombre"
              background-color="transparent"
            />
            <BaseInput
              class="ui-form-field"
              v-model="busquedaPersonal.segundoNombre"
              label="Segundo nombre"
              background-color="transparent"
            />
            <BaseInput
              class="ui-form-field"
              v-model="busquedaPersonal.apaterno"
              label="Apellido paterno"
              background-color="transparent"
            />
            <BaseInput
              class="ui-form-field"
              v-model="busquedaPersonal.amaterno"
              label="Apellido materno"
              background-color="transparent"
            />
            <BaseInput
              class="ui-form-field"
              v-model="busquedaPersonal.curp"
              label="CURP"
              background-color="transparent"
            />
            <BaseInput
              class="ui-form-field"
              v-model="busquedaPersonal.CUIP"
              label="CUIP"
              background-color="transparent"
            />
          </v-card-text>
          <v-card-actions class="justify-center pb-8 ui-module-actions">
            <v-container class="py-0">
              <v-row justify="center" class="mb-3">
                <v-col cols="10" align="center">
                  <TextButton
                    class="ui-module-btn-solid"
                    @click="triggerSearchPersonal()"
                    :disabled="loading || emptyForm"
                    :loading="loading"
                  >
                    Realizar búsqueda
                  </TextButton>
                </v-col>
              </v-row>
              <v-row justify="center" v-if="hasAccessToFeature(perfil, FEATURES.REGISTRO_NUEVO_PERSONAL)">
                <v-col cols="10" align="center">
                  <TextButton class="ui-module-btn-solid" to="/recursos_humanos/registro_personal">
                    Registro de nuevo personal
                  </TextButton>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else align="start">
      <v-col cols="12">
        <v-row>
          <v-col cols="4">
            <TextButton class="ui-module-btn-outline" @click="RESET_BUSQUEDA_PERSONAL()"
              >Realizar nueva búsqueda</TextButton
            >
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="4">
            <BaseInput
              class="ui-form-field"
              label="Filtrar elementos"
              v-model="filtroPersonal"
              background-color="transparent"
            ></BaseInput>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="4" xl="3" v-for="personal in filteredPersonal" :key="personal.id">
        <v-card class="ui-module-card ui-module-fade-in-up" color="secondary" elevation="8">
          <v-card-title>
            <v-container>
              <v-row>
                <v-col cols="12" align="center">
                  <v-avatar rounded color="primary" size="80" v-if="!hasFoto(personal) || personal.fotoError">
                    <v-icon x-large color="secondary">mdi-account</v-icon>
                  </v-avatar>
                  <v-img
                    v-else
                    :src="personal.foto"
                    max-height="80"
                    max-width="80"
                    @error="personal.fotoError = true"
                  />
                </v-col>
                <v-col cols="12" align="center">
                  <div class="text-h6 primary--text font-weight-bold">{{ personal.apaterno }}</div>
                  <div class="text-subtitle-1 primary--text">
                    {{ personal.amaterno + ' ' + personal.nombre + ' ' + personal.segundoNombre }}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-title>
          <v-card-actions class="secondary darken-1 ui-module-actions">
            <v-container>
              <v-row>
                <v-col cols="12" class="actions-row-wrapper" align="right">
                  <v-tooltip
                    bottom
                    color="black"
                    v-if="hasAccessToFeature(perfil, FEATURES.REGISTRAR_TRAMITE_ADMINISTRATIVO)"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="primary secondary--text action-btn ui-module-icon-action"
                        elevation="8"
                        :to="{
                          name: 'recursos_humanos.registro_falta_administrativa',
                          params: { id: personal.idPersonal },
                        }"
                        icon
                        v-on="on"
                        v-bind="attrs"
                        ><v-icon>mdi-book-alert</v-icon></v-btn
                      >
                    </template>
                    <span>Registrar trámite administrativo</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black" v-if="hasAccessToFeature(perfil, FEATURES.CAMBIO_DE_ESTATUS)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="primary secondary--text action-btn ui-module-icon-action"
                        elevation="8"
                        :to="{ name: 'actualizaEstatus', params: { id: personal.idPersonal } }"
                        icon
                        v-on="on"
                        v-bind="attrs"
                        ><v-icon>mdi-police-badge</v-icon></v-btn
                      >
                    </template>
                    <span>Cambiar de estatus</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="primary secondary--text action-btn ui-module-icon-action"
                        elevation="8"
                        :to="{ name: 'asignacionTurno', params: { id: personal.idPersonal } }"
                        icon
                        v-on="on"
                        v-bind="attrs"
                        ><v-icon>mdi-timetable</v-icon></v-btn
                      >
                    </template>
                    <span>Asignación de turno</span>
                  </v-tooltip>
                  <v-tooltip
                    bottom
                    color="black"
                    v-if="hasAccessToFeature(perfil, FEATURES.ASIGNACION_PUESTO_FUNCION_ADSCRIPCION)"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="primary secondary--text action-btn ui-module-icon-action"
                        elevation="8"
                        :to="{ name: 'asignaSedePersonal', params: { id: personal.idPersonal } }"
                        icon
                        v-on="on"
                        v-bind="attrs"
                        ><v-icon>mdi-office-building-marker</v-icon></v-btn
                      >
                    </template>
                    <span>Asignación de puesto, función y adscripción</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="primary secondary--text action-btn ui-module-icon-action"
                        elevation="8"
                        :to="{
                          path: '/recursos_humanos/expediente_personal/' + personal.idPersonal,
                          params: { id: personal.idPersonal },
                        }"
                        icon
                        v-on="on"
                        v-bind="attrs"
                        ><v-icon>mdi-file-account</v-icon></v-btn
                      >
                    </template>
                    <span>Ver expediente</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="primary secondary--text action-btn ui-module-icon-action"
                        elevation="8"
                        @click="generarConstanciaNoAdeudo(personal)"
                        icon
                        v-on="on"
                        v-bind="attrs"
                        ><v-icon>mdi-file-word</v-icon></v-btn
                      >
                    </template>
                    <span>Constancia de No Adeudo</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black" v-if="hasAccessToFeature(perfil, FEATURES.VER_ASISTENCIAS)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="primary secondary--text action-btn ui-module-icon-action"
                        elevation="8"
                        :to="{
                          name: 'recursos_humanos.asistencias',
                          params: { id: personal.idPersonal },
                        }"
                        icon
                        v-on="on"
                        v-bind="attrs"
                        ><v-icon>mdi-clipboard-check-outline</v-icon></v-btn
                      >
                    </template>
                    <span>Asistencias</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
/* Estilos modernos para Personal Recursos Humanos */
.actions-row-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
}

/* Títulos y textos */
.text-h6.font-weight-bold {
  color: #e0e0e0 !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.primary--text {
  color: #e0e0e0 !important;
}

.text-subtitle-1.primary--text {
  color: rgba(224, 224, 224, 0.8) !important;
}

.text-caption.primary--text {
  color: rgba(224, 224, 224, 0.75) !important;
  font-weight: 500 !important;
}

.secondary--text {
  color: var(--v-secondary-base) !important;
}

/* Avatares */
::v-deep .v-avatar {
  border: 2px solid rgba(var(--v-secondary-base-rgb), 0.4);
  transition: all 0.3s ease;
  background: rgba(26, 38, 46, 0.8) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

::v-deep .v-card:hover .v-avatar {
  transform: rotate(5deg) scale(1.1);
  border-color: var(--v-secondary-base);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
}

::v-deep .v-avatar .v-icon {
  color: var(--v-secondary-base) !important;
  filter: drop-shadow(0 4px 12px rgba(var(--v-secondary-base-rgb), 0.6));
}

/* Imágenes */
::v-deep .v-image {
  border-radius: 8px;
  border: 2px solid rgba(var(--v-secondary-base-rgb), 0.4);
  transition: all 0.3s ease;
}

::v-deep .v-card:hover .v-image {
  border-color: var(--v-secondary-base);
  transform: scale(1.05);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}

/* Botones - Oscuros para contrastar */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6) !important;
}

/* Botones con fondo oscuro que contrastan */
::v-deep .ui-module-btn-solid {
  background: linear-gradient(135deg, var(--v-secondary-base) 0%, var(--v-secondary-lighten1) 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 16px rgba(var(--v-secondary-base-rgb), 0.4) !important;
}

::v-deep .ui-module-btn-outline {
  background: rgba(var(--v-secondary-base-rgb), 0.08) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.35) !important;
  color: var(--v-secondary-base) !important;
}

::v-deep .v-btn.primary,
::v-deep .v-card-actions .action-btn {
  background: linear-gradient(135deg, #1a262e 0%, #0f1a1f 100%) !important;
  color: var(--v-secondary-base) !important;
  border: 2px solid rgba(var(--v-secondary-base-rgb), 0.4) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3) !important;
}

::v-deep .action-btn {
  margin: 0 !important;
}

::v-deep .v-btn.primary:hover,
::v-deep .v-card-actions .action-btn:hover {
  background: linear-gradient(135deg, #0f1a1f 0%, #050a0f 100%) !important;
  border-color: var(--v-secondary-base) !important;
  color: #ffffff !important;
}

::v-deep .v-btn.secondary--text {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-btn:disabled {
  opacity: 0.5 !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease;
  color: var(--v-secondary-base) !important;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.2);
  color: #ffffff !important;
}

/* Input fields */
::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.68) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .ui-form-field .v-label--active {
  color: var(--v-secondary-base) !important;
}

::v-deep .ui-form-field .v-text-field__details,
::v-deep .ui-form-field .v-messages__message {
  color: rgba(224, 224, 224, 0.55) !important;
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(26, 38, 46, 0.95) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.3);
  border-radius: 8px;
  color: #e0e0e0 !important;
  font-weight: 500;
  padding: 8px 12px;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(var(--v-secondary-base-rgb), 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--v-secondary-base-rgb), 0.6);
}

.fab {
  position: fixed;
  bottom: 24px;
  right: 24px;
}

@media (max-width: 1400px) {
  .actions-row-wrapper {
    gap: 4px;
  }
}
</style>
<script>
import { Packer } from 'docx'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import _ from 'lodash'
import BaseInput from '@/components/base/BaseInput.vue'
import TextButton from '@/components/base/TextButton.vue'
import moment from 'moment'
import ConstanciaNoAdeudo from '@/utils/doc-generator/recursos-humanos/ConstanciaNoAdeudo.js'

export default {
  components: {
    BaseInput,
    TextButton,
  },
  data() {
    return {
      loading: false,
      filtroPersonal: '',
      mostrarConstancia: false,
    }
  },

  computed: {
    ...mapGetters({
      perfil: 'getPerfil',
    }),

    ...mapGetters('personal', {
      resultadosPersonal: 'getPersonal',
      busquedaPersonal: 'getBusquedaPersonal',
    }),

    ...mapGetters('tipoAmbito', {
      tipoAmbito: 'getTipoAmbito',
    }),

    ...mapGetters('dependencia', {
      dependencias: 'getDependencias',
    }),

    filteredPersonal: function () {
      return this.resultadosPersonal.filter((personal) => {
        return (
          this.getFullName(personal).toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0 ||
          personal.CUIP.toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0 ||
          personal.rfc.toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0 ||
          personal.curp.toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0
        )
      })
    },

    emptyForm() {
      if (
        this.busquedaPersonal.nombre === '' &&
        this.busquedaPersonal.segundoNombre === '' &&
        this.busquedaPersonal.apaterno === '' &&
        this.busquedaPersonal.amaterno === '' &&
        this.busquedaPersonal.curp === '' &&
        this.busquedaPersonal.CUIP === ''
      ) {
        return true
      } else return false
    },
  },

  methods: {
    ...mapActions('personal', ['searchPersonal']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapMutations('personal', ['RESET_BUSQUEDA_PERSONAL']),

    async triggerSearchPersonal() {
      this.loading = true

      await this.searchPersonal(this.busquedaPersonal)
      if (this.resultadosPersonal.length == 0) {
        this.SET_SNACKBAR_MESSAGE('Búsqueda sin resultados.')
      }

      this.loading = false
    },
    hasFoto(personal) {
      const urlSinFoto =
        'https://edofza.eoninnovaction.com/CICG_SEG/ESTADO_FUERZA/Files/Fotografia/frente_AARD930724H214693851.jpg'
      return (
        personal.foto &&
        typeof personal.foto === 'string' &&
        personal.foto.trim() !== '' &&
        personal.foto !== urlSinFoto
      )
    },
    getFullName(personal) {
      return `${personal.apaterno} ${personal.amaterno} ${personal.nombre} ${personal.segundoNombre || ''}`.trim()
    },
    async generarConstanciaNoAdeudo(personal) {
      const fechaHoy = moment().format('YYYY-MM-DD')
      const nombreCompleto = `${personal.apaterno} ${personal.amaterno} ${personal.nombre} ${
        personal.segundoNombre || ''
      }`.trim()
      const area = personal.CatArea && personal.CatArea.nombre ? personal.CatArea.nombre : ''
      const fechaIngreso = personal.fechaIngresoEdoFza || ''
      const fechaBaja = personal.fechaBaja || fechaHoy

      const doc = new ConstanciaNoAdeudo({
        nombre: nombreCompleto,
        rfc: personal.rfc || '',
        fecha: fechaHoy,
        area: area,
        fechaIngreso: fechaIngreso,
        fechaBaja: fechaBaja,
      })
      const newDoc = await doc.generate()
      const blob = await Packer.toBlob(newDoc)
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `ConstanciaNoAdeudo_${nombreCompleto}.docx`
      a.click()
      window.URL.revokeObjectURL(url)
    },
  },
}
</script>
